import React, { useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import SidePanelPartys from './SidePanelPartys';
import { useGetContractPartysByBookId, useGetPartysByBookId } from '../../../../hooks/services/sBook/useOfParty'
import '../../../../styles/css/RelatedConcept.css'
import DisabledCard from '../../../Templates/CCard/DisabledCard';
import { useTranslation } from "react-i18next";
import PartyCard from './PartyCard';
import ToolBar from '../../../../components/Common/Toolbar';
import { savePartysByBookId } from "../../../../services/sBook/party.service";
import Message from '../../../Common/Message';
import { __PartyType } from '../../../../common/Dictionaries';
import NoDataLayer from '../../../Common/NoDataLayer'
import StatusHeaderItem from '../StatusHeaderItem';
import { saveBook } from "../../../../services/sBook/book.service";
import Cookies from 'js-cookie'
import { useSelector } from 'react-redux';
import { isNullUndefined } from '../../../../common/Helpers';
import { MessageBarType } from '@fluentui/react';
import { findPartyLengthErrors } from './partyRules';

function PartyCreationBox(props) {
    const { t } = useTranslation();
    Cookies.set('name', 'value', { domain: 'localhost' })

    const {
        _contractParties: contractParties,
        _fireSetContractParties: fireSetContractParties
    } = useSelector((state) => state.bookState);

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject;
    const inputParam_SetterBookPartyList = props.setterBookPartyList;
    const inputParam_RoleList = props.roleList;
    const inputParam_SetterSelectedCard = props.setterSelectedCard;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    const inputParam_SetPartyCardIsSelected = props.setPartyCardIsSelected !== null && props.setPartyCardIsSelected !== undefined ? props.setPartyCardIsSelected : null;
    const inputParam_StatusFly = props.statusFly !== null && props.statusFly !== undefined ? props.statusFly : null;
    const inputParam_RelatedConceptHasPartys = props.relatedConceptHasPartys !== null && props.relatedConceptHasPartys !== undefined ? props.relatedConceptHasPartys : false;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;
    const inputParam_IsCreatrionMode = props.isCreatrionMode !== null && props.isCreatrionMode !== undefined ? props.isCreatrionMode : false;
    
    //Parametros de componente.
    const [successful, setSuccessful] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const [bookPartyList, setBookPartyList] = useState(null);
    useGetContractPartysByBookId(inputParam_BookObject.id, bookPartyList, setBookPartyList, inputParam_SetterBookPartyList, false, true, contractParties, fireSetContractParties)
    
    const [selectedCard, setSelectedCard] = useState(null);
    

    const selectCard = (card) => {
        inputParam_SetterSelectedCard(card)
        setSelectedCard(card)
        inputParam_SetPartyCardIsSelected && inputParam_SetPartyCardIsSelected(true);
    };

    const customSetBookPartyList = (leBuList, bookPartyList) => {
        leBuList.forEach(lebu => {
            let auxLeBu = lebu;
            auxLeBu.id = (lebu.id < 0 ? lebu.id * -1 : lebu.id);

            let item = bookPartyList.find(x => (x.legalEntityId !== null ? x.legalEntityId === auxLeBu.id : (x.businessUnitId !== null ? x.businessUnitId === auxLeBu.id : null)) && (x.legalEntityId !== null ? __PartyType.LegalEntity : (x.businessUnitId !== null ? __PartyType.BusinessUnit : null)) === auxLeBu.typeId);
            if (item === undefined) {
                bookPartyList.push({
                    id: 0,
                    bookId: inputParam_BookObject.id,
                    legalEntityId: lebu.typeId === __PartyType.LegalEntity ? (lebu.id < 0 ? lebu.id * -1 : lebu.id) : null,
                    businessUnitId: lebu.typeId === __PartyType.BusinessUnit ? (lebu.id < 0 ? lebu.id * -1 : lebu.id) : null,
                    partyNemo: "",
                    partyCode: lebu.code,
                    name: lebu.name,
                    manager: lebu.manager,
                    counterParty: lebu.counterParty,
                    userCounts: 0
                })
            }
        });

        //Ver como arreglar esto (data data).
        setBookPartyList({data:{data: bookPartyList}});
    }

    const showSaveError = (text) => {
        setShowMessage(true);
        setSuccessful(false);
        setMessageType("error");
        setMessage(text);
    };

    //Detalle que entrega la API cuando rechaza el modelo (400), para no dejar al usuario con un error genérico.
    const getValidationDetail = (error) => {
        const validationErrors = error && error.response && error.response.status === 400 ? (error.response.data && error.response.data.errors) : null;
        return isNullUndefined(validationErrors) ? '' : Object.values(validationErrors).flat().join(' ');
    };

    const onSavePartys = (e) => {
        let bookPartyToSave = bookPartyList.data.data.filter(x => x.id === 0);

        if (bookPartyToSave.length > 0) {
            //Avisar antes de enviar si algun codigo o nombre no cabe en lo que acepta la API.
            const lengthErrors = findPartyLengthErrors(bookPartyToSave);
            if (lengthErrors.length > 0) {
                showSaveError(lengthErrors.map(lengthError => t('data-lang-msg-partyfieldtoolong', {
                    field: t(lengthError.field === 'code' ? 'data-lang-lbl-code' : 'data-lang-lbl-name'),
                    value: lengthError.value,
                    length: lengthError.length,
                    max: lengthError.max
                })).join(' '));
                return;
            }

            //Guardar elementos partys.
            savePartysByBookId(inputParam_BookObject.id, bookPartyToSave).then((response) => {
                //inputParam_BookObject.statusId = 1;

                saveBook(inputParam_BookObject).then(() => {
                    setShowMessage(true);
                    setSuccessful(true);
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'));

                    for (let index = 0; index < bookPartyList.data.data.length; index++) {
                        const element = bookPartyList.data.data[index];

                        for (let index2 = 0; index2 < response.data.data.length; index2++) {
                            const element2 = response.data.data[index2];
                            if (element2.id === element.id) {
                                response.data.data[index2].userCounts = element.userCounts;
                            }
                        }
                    }

                    //Supuestamente se devolverá el mismo listado pero con ids, esto hará que las opciones de "seleccionar usuario" de las cards nuevas aparezca, dado que ahora la card poseerá id.
                    setBookPartyList(response);

                    //Este setter se utiliza en la pagina superior para ser entregado a box de secciones y secciones/parte. Para determinar si se deben o no desbloquear los componentes.
                    inputParam_SetterBookPartyList(response);
                }).catch(() => {
                    setShowMessage(true);
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'));
                });
            }).catch((error) => {
                const detail = getValidationDetail(error);
                showSaveError(detail !== '' ? `${t('data-lang-msg-operationerror')} ${detail}` : t('data-lang-msg-operationerror'));
            });
        }
    };

    const onDeleteParty = (party) => {
        let auxArray = []

        //Quitar la party eliminada del array de partys, asi no se debe ir a buscarnuevamente la data.
        //.silice no funciona por alguna razon.
        for (let index = 0; index < bookPartyList.data.data.length; index++) {
            const element = bookPartyList.data.data[index];

            if (party.id !== 0) {
                if (!(element.id === party.id && (element.legalEntityId === party.legalEntityId && element.businessUnitId === party.businessUnitId))) {
                    auxArray.push(element);
                }
            } else {
                if (!(element.partyCode === party.partyCode && (element.legalEntityId === party.legalEntityId && element.businessUnitId === party.businessUnitId))) {
                    auxArray.push(element);
                }
            }
        }

        setBookPartyList({data: {data: auxArray}});
        inputParam_SetterBookPartyList({data: {data: auxArray}})
    };

    const onSelectSpecificPartys = (e) => {
        if (inputParam_BookObject.id !== 0) {
            setIsPanelOpen(true);
        } else {
            alert("Debe crear el libro primero.");
        }
    };

    const toolBarItems_Parties  = [
        {
            style: { display: bookPartyList && bookPartyList.data.data.filter(x => x.id === 0).length > 0 ? "block" : "none" },
            key: 'save',
            text: t('data-lang-btn-save'),
            iconProps: { iconName: 'Save' },
            onClick: onSavePartys,
        },
        {
            key: 'create',
            text: t('data-lang-btn-select'),
            iconProps: { iconName: 'CircleAddition' },
            onClick: onSelectSpecificPartys,
        },
    ];

    const displayPartyBox = inputParam_BookObject.id !== null
    
    return (
        <Card className='book-partys-form h-100'>
            <DisabledCard display={ !displayPartyBox } />
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <Row>
                        {
                            inputParam_EditMode === true && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                            <Col className='col-auto ms-auto'>
                                <StatusHeaderItem index={ 3 } statusId={ inputParam_StatusFly } />
                            </Col>
                        }
                        <Col className={ inputParam_EditMode ? "ps-4 ms-3" : "" } >
                            <b>{t('data-lang-boxname-partys')}</b>
                        </Col>
                    </Row>
                </Card.Title>
            </Card.Header>
            <Card.Footer className='w-100' style={{padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <div className='book-toolbar d-flex float-end'>
                    { inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) && <ToolBar items={ toolBarItems_Parties } display={displayPartyBox} /> }
                </div>
            </Card.Footer>
            <Card.Body className="book-partys-form-body pt-2 w-100 h-100">
                <Row className='layerBlockedContent'>
                    {
                        displayPartyBox &&
                        <>
                            {
                                bookPartyList && bookPartyList.data.data.map((party, index) => 
                                    <Col className={`mb-2`} key={ index } xs={12} sm={12} md={6} lg={6} xl={6} xxl={4}>
                                        <PartyCard
                                            bookId={ inputParam_BookObject.id }
                                            bookObject={inputParam_BookObject}
                                            key={ index }
                                            partyItem={ party }
                                            setterDeleteParty={onDeleteParty}
                                            roleList={ inputParam_RoleList }
                                            selectedCard={ selectedCard }
                                            setterSelectedCard={ selectCard }
                                            editMode={ inputParam_EditMode }
                                            userHasConfigRoleAction={(inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction)}
                                            bookPartyList={ bookPartyList }
                                            setBookPartyList={ setBookPartyList }
                                            setterMessage={ setMessage } setterShowMessage={setShowMessage} setterSuccessful={setSuccessful} setterMessageType={ setMessageType }
                                            relatedConceptHasPartys={inputParam_RelatedConceptHasPartys}
                                        />
                                    </Col>
                                )
                            }
                            {
                                (bookPartyList && bookPartyList.data.data.length === 0) &&
                                <NoDataLayer display={ !displayPartyBox } />
                            }
                            {
                                bookPartyList &&
                                <SidePanelPartys
                                    bookId={inputParam_BookObject.id}
                                    selectedLeBuList={ bookPartyList.data.data }
                                    setterSelectedLeBuList={ customSetBookPartyList }
                                    isPanelOpen={ isPanelOpen }
                                    setterIsPanelOpen={ setIsPanelOpen }
                                    relatedConceptHasPartys={inputParam_RelatedConceptHasPartys}
                                />
                            }
                        </>
                    }
                    <NoDataLayer display={ !displayPartyBox } />
                </Row>
            </Card.Body>
            <Card.Footer>
                <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                {
                    inputParam_BookObject.hasMilestone === true &&
                    <Message message={ t('data-lang-msg-needmanagerandcounterpartys') } display={ true } messageType={ 'warning'} setterShowMessage={ undefined } />
                }
            </Card.Footer>
        </Card>
    );
}

export default PartyCreationBox;